import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class RouteService {

	constructor(private routerService: Router) { }

	/**
	 * Se valida la ruta para impedir el ingreso a los menús por url
	 * @param ruta es la ruta a la cual está ingresando actualmente
	 * @author Bvelez
	 * @returns 
	 */
	validarRuta(ruta: ActivatedRouteSnapshot): Observable<boolean> {
		return new Observable((resolve) => {
			try {
				const link =  ruta.routeConfig.path;
				resolve.next(true);
				// if (link.includes('/aprobar')) {
					
				// } else {
				// 	window.history.back();
				// 	resolve.next(false);
				// }
				
			} catch (error) {
				console.log(error);
			}
		});
	}
}
